import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const AI_APPLICATION_COMPONENTS_KEY = 'ai-application-components';

const STALE_TIME_MS = 30_000;

export function useAiApplicationComponents({
  aiApplicationId,
  enabled = true,
}: {
  aiApplicationId: string | null;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [AI_APPLICATION_COMPONENTS_KEY, aiApplicationId],
    queryFn: () =>
      terraProxyApiClient.getAiApplicationComponents(aiApplicationId ?? ''),
    enabled: Boolean(aiApplicationId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    components: query.data?.components ?? [],
    relations: query.data?.relations ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
